import { Grid, Typography, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ClassExtended, DbUser, InsightsCtx, UserCtx } from "../../interfaces";
import { PageContainer } from "../../components/v2/PageContainer";
import { InsightsContext } from "../../context/InsightsContext";
import { ClassCodeCard } from "../../components/v3/insights/classSettings/ClassCodeCard";
import { SendLoginCredentialsCard } from "../../components/v3/insights/classSettings/SendLoginCredentialsCard";
import { ClassDetails } from "../../components/v3/insights/classSettings/ClassDetails";
import { UserContext } from "../../context/UserContext";
import { Role, _AuthType } from "../../enums";
import { MacsAuthenticator } from "../../hooks/useMacsAuthenticator";

export type ClassSettingsPageProps = {
  currentUser: DbUser;
};

export function ClassSettingsPage(props: ClassSettingsPageProps) {
  const insightsCtx = useContext(InsightsContext) as InsightsCtx;
  const userCtx = useContext(UserContext) as UserCtx;
  const currentUser = userCtx.dbUser as DbUser;
  const [currentClassDetails, setCurrentClassDetails] = useState({} as ClassExtended);
  useEffect(() => {
    if (!insightsCtx.classInfo) {
      return;
    }
    setCurrentClassDetails(insightsCtx.classInfo);
  }, [insightsCtx.classInfo]);
  return (
    <>
      <Stack
        direction="row"
        sx={{ height: "150px", backgroundColor: "#0E556F", padding: "32px" }}
        alignItems="center">
        <Typography variant="h1" component="div" color="white">
          Class Settings
        </Typography>
      </Stack>
      <PageContainer>
        <Grid
          container
          direction={"row"}
          spacing={4}
          justifyContent={"space-between"}
          alignItems={"flex-start"}>
          <Grid item xs={8}>
            <Stack spacing={"24px"}>
              <ClassDetails
                classDetails={currentClassDetails}
                updateCachedClassSettings={insightsCtx.updateCachedClassSettings}
              />
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={"24px"}>
              {currentUser.role === Role.super && (
                <ClassCodeCard classCode={currentClassDetails.class_code} />
              )}
              {MacsAuthenticator.authHook.authType !== _AuthType.LTI && (
                <SendLoginCredentialsCard classDetails={currentClassDetails} />
              )}
            </Stack>
          </Grid>
        </Grid>
      </PageContainer>
    </>
  );
}
